import * as React from "react";

function SvgQuestionCircle({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="currentColor"
          d="M12 2.25c5.385 0 9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25zm0 1.5a8.25 8.25 0 100 16.5 8.25 8.25 0 000-16.5zm0 11.125c.475 0 .862.379.875.85v.025a.875.875 0 11-.875-.875zM14.9 10c0 .87-.385 1.45-1.176 2.125l-.27.223-.338.273-.066.057-.144.132-.092.096-.05.063c-.01.016-.014.026-.014.031a.75.75 0 01-1.5 0c0-.575.286-.993.815-1.454l.17-.144.367-.295c.586-.477.798-.764.8-1.06-.045-.716-.625-1.271-1.388-1.299l-.145.001a1.432 1.432 0 00-1.453 1.106.749.749 0 11-1.46-.339c.318-1.372 1.567-2.324 2.903-2.265C13.442 7.163 14.8 8.371 14.9 10z"
        />
      </g>
    </svg>
  );
}

export default SvgQuestionCircle;
